import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Login from "./pages/Login";
import Home from "./pages/Home";
import CreateInvoice from "./pages/CreateInvoice";
import CreateQuotation from "./pages/CreateQuotation";
import ViewInvoice from "./pages/ViewInvoice";
import ViewQuotation from "./pages/ViewQuotation";
import RegisterCompany from "./pages/RegisterCompany";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

function ScrollHandler() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollHandler />
      <Routes>
        {/* LOGIN ROUTE */}
        <Route path="/" element={<Login />} />

        {/* PROTECTED HOME ROUTE */}
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        <Route
          path="/register-company"
          element={
            <ProtectedRoute>
              <RegisterCompany />
            </ProtectedRoute>
          }
        />

        {/* PROTECTED CREATE DOCUMENT ROUTE */}
        <Route
          path="/createinvoice"
          element={
            <ProtectedRoute>
              <CreateInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/createquotation"
          element={
            <ProtectedRoute>
              <CreateQuotation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-invoice/:id"
          element={
            <ProtectedRoute>
              <CreateInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-quotation/:id"
          element={
            <ProtectedRoute>
              <CreateQuotation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-invoice/:id"
          element={
            <ProtectedRoute>
              <ViewInvoice />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-quotation/:id"
          element={
            <ProtectedRoute>
              <ViewQuotation />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
